import { ActionButton, HotelCardWrap } from "./styles";
import { DEMO_HOTEL_ADDRESS, IMAGES } from "./images";

const HotelCard = ({ hotelName, onAddPass }) => {
  if (!hotelName) return null;

  return (
    <HotelCardWrap>
      <img src={IMAGES.hotel} alt="" />
      <div className="hotel-body">
        <h3>{hotelName}</h3>
        <address>{DEMO_HOTEL_ADDRESS}</address>
        <ActionButton
          type="button"
          onClick={onAddPass}
        >
          Add Northbank Pass
        </ActionButton>
      </div>
    </HotelCardWrap>
  );
};

export default HotelCard;
